import script from "./EditSubhireModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSubhireModal.vue?vue&type=script&setup=true&lang=js"

import "./EditSubhireModal.vue?vue&type=style&index=0&id=6a31358d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a31358d"]])

export default __exports__